export enum listTypes {
  BU = 'B',
  Global = 'G',
}
